import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Fatih Emre Eryiğit — kişisel iletişim sayfası.
 *
 * 15.09.2026'da istendi. İngilizcesiyle aynı bölümler, aynı bilgiler; yalnızca
 * söyleyiş Türkçe. Unvan, fotoğraf ve özgeçmiş verilmediği için burada da yok —
 * İngilizce sayfadaki `check` notu bu eksikleri soruyor ve iki dilde
 * tekrarlanmıyor.
 */
const EMAIL = 'fatih.eryigit@digitopia.ai'
const PHONE_DISPLAY = '+90 553 672 33 83'
const PHONE_DIAL = 'tel:+905536723383'

export const teamFatihEmreEryigit: WrittenPage = {
  navLabel: 'Fatih Emre Eryiğit',
  title: 'Fatih Emre Eryiğit',
  description:
    'Digitopia’dan Fatih Emre Eryiğit ile iletişim: fatih.eryigit@digitopia.ai, +90 553 672 33 83.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Digitopia',
      headline: 'Fatih Emre Eryiğit',
      align: 'center',
      ctas: [
        { label: 'E-posta', href: `mailto:${EMAIL}` },
        { label: 'Ara', href: PHONE_DIAL },
        // 17.09.2026: telefona doğrudan kaydetmek için vCard. Dosya
        // `public/vcf/` içinde, sayfanın slug'ıyla aynı adda.
        { label: 'Rehbere kaydet', href: '/vcf/fatih-emre-eryigit.vcf' },
      ],
    },
    {
      kind: 'features',
      heading: 'İletişim',
      columns: 2,
      items: [
        {
          title: EMAIL,
          note: 'E-posta',
          href: `mailto:${EMAIL}`,
        },
        {
          title: PHONE_DISPLAY,
          note: 'Türkiye',
          href: PHONE_DIAL,
        },
      ],
    },
    {
      kind: 'cta',
      heading: 'Kişi yerine firmayla mı başlamak istersiniz?',
      sub: 'İletişim formu tüm ekibe ulaşır; Hakkımızda ise birlikte çalışacağınız diğer isimleri anlatır.',
      tone: 'band',
      ctas: [
        { label: 'Digitopia ile iletişime geçin', href: LINKS.contact },
        { label: 'Hakkımızda', href: LINKS.about },
      ],
    },
  ],
}
